import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const RelationsRedux = createActions({},
  {
    prefix: 'RELATIONS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = RelationsRedux
export const RelationsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/RelationsRedux.js